// Auto-generated from server/src/Jobs.Domain/Constants/ProjectTypeConstants.cs
// Do not modify manually - run 'npm run generate-constants' to regenerate

export const ProjectTypeConstants = {
  BasementFinishing: '8d24643e-875c-4e0c-b02d-54e6a2136cbd',
  BasementWaterproofing: 'c3d4bc11-690b-4f63-bc52-c7381f1ebe08',
  Commercial: 'fe217b08-8533-f111-8ef3-6045bdd407c0',
  ConcreteCoatings: 'f3fb8a72-4584-496e-b6a9-d18c2cca457e',
  ConcreteLifting: '52c1ccd6-5920-4f6e-8e11-323867040809',
  ConcreteReplacement: '25f0f65b-eefe-4153-9588-263def51a7bf',
  CrawlspaceDrainage: '28343883-bcf8-4484-9e9d-2498c2f694a6',
  CrawlspaceStructural: 'be348f38-2ad2-49a9-ac53-e6d927ae992a',
  Egress: '892ea571-e8ce-4319-a954-e4a9a4f8f608',
  Electrical: '41d89a53-4f94-4a8d-a3c2-e60198a33f61',
  Encapsulation: 'c01df8df-57fe-45cf-b7bd-70a08ffe3df1',
  ExteriorDrainage: '344ec25a-144a-4402-ba57-d486795cead9',
  Gutters: 'c464b736-05b9-482c-9a2a-71652f5cea58',
  NonInstallableServices: 'c1d70fde-d21d-43f1-95e4-5e78938b2cb9',
  Piering: '6e4dd99d-adf3-436e-bdbf-32dcf3233b6b',
  Plumbing: 'e84118e6-7558-4fd3-a1f5-d73a482bb16b',
  Radon: '06ebf7ba-b4b5-4dd4-9fac-d5c79779ea09',
  SMPs: '5e9c44d4-fad9-4a0e-8c11-8b67d4df9e04',
  SoilInjection: '817e321d-91a7-4d42-a1d2-87a25185f626',
  SubContractor: 'eb5ce814-461a-4e62-8252-03c00e8994ee',
  Other: '573c938b-cc66-4302-b0ce-a08752c5230c',
  WallRepair: '1afefea0-8ac2-46f0-82ba-3c0cceaf2fdc',
  Zebron: '2a335f1a-8604-4114-8508-b062fd8febe0',
  ServiceRevenue: '449a2303-0331-f111-8ef3-6045bdd407c0'
} as const;
